module.exports = __webpack_public_path__ + "static/s_display_l-ccf1108379f98897de7a2aa7ec88aaf1.woff";